import React, { useEffect, useRef } from "react";
import { useInViewport } from "react-in-viewport";

import Link from "ab-link";
import MenuItem from "./MenuItem";
import ParagraphText from "ab-paragraph-text";
import Text from "ab-text";

import "./faq.scss";

const Faq = ({
  title = "Un menú a tu medida",
  text = [],
  content,
  items = [],
  h1,
  animated,
  className,
  classname,
  navlink,
  link,
}) => {
  // console.log("Faq", items, carta, menu);

  const myRef = useRef();

  const { inViewport, enterCount, leaveCount } = useInViewport(
    myRef,
    { threshold: 0.5 },
    {
      onEnterViewport: () => {
        // console.log("entered viewport");
      },
    },
    { disconnectOnLeave: false }
  );
  const handleScroll = () => {
    const element = document.getElementById(`menu-#${navlink}`);
    const menu = document.getElementById("history-menu");

    if (element) {
      if (inViewport) {
        if (!element?.classList?.contains("selected")) {
          const children = menu?.querySelectorAll("li");
          children.forEach(function(e) {
            if (e.id !== element.id) {
              e?.classList.remove("selected");
              e?.classList.add("not-selected");
            }
          });
          element?.classList.add("selected");
          element?.classList.remove("not-selected");
          menu.scrollLeft = element?.offsetLeft - 10;
        }
      } else {
        if (!element?.classList?.contains("not-selected")) {
          element?.classList.remove("selected");
          element?.classList.add("not-selected");
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inViewport]);

  return (
    <>
      <a className="reference" style={{ top: -100 }} id={navlink} />

      <div
        className={`faq${
          text.length > 0 || content?.length > 0 ? " padding" : ""
        } ${className || ""} ${classname || ""}`}
        ref={myRef}
      >
        {h1 ? <Text element="h1">{h1}</Text> : null}
        <div className="row">
          <div>
            <Text element="h2" animated={animated}>
              {title}
            </Text>
            <ParagraphText text={text} content={content} singleColumn />
          </div>

          {items?.length <= 4 ? (
            <div className="faq-lista">
              {items?.map((itm, index) => (
                <MenuItem
                  key={`menu-item-${index}`}
                  title={itm.title}
                  description={itm.description}
                />
              ))}
              {link ? (
                <Link
                  prefetch={false}
                  text={link.text || link.title}
                  href={link.href || link.url}
                  target={link.target}
                  style={{ marginTop: 45 }}
                />
              ) : null}
            </div>
          ) : null}
        </div>

        {items?.length > 4 ? (
          <>
            <div className="row two-column">
              <div className="faq-lista">
                {items?.map((itm, index) => (
                  <MenuItem
                    key={`menu-item-${index}`}
                    title={itm.title}
                    description={itm.description}
                  />
                ))}
              </div>
            </div>
            {link ? (
              <Link
                prefetch={false}
                text={link.text || link.title}
                href={link.href || link.url}
                target={link.target}
              />
            ) : null}
          </>
        ) : null}
      </div>
    </>
  );
};

export default Faq;
